module.exports = __webpack_public_path__ + "img/services.72af3bbe.svg";